import { Action } from '@retail/auth/types';
import { Chip, Tooltip } from '@mui/material';

const actionTextMap = {
  CREATE: { text: 'Create', short: 'C', tint: 'create' },
  READ: { text: 'Read', short: 'R', tint: 'read' },
  UPDATE: { text: 'Update', short: 'U', tint: 'update' },
  DELETE: { text: 'Delete', short: 'D', tint: 'delete' },
} as const;

interface Props {
  action: Action;
}

export const ActionChip = ({ action }: Props) => {
  const actionText = actionTextMap[action];
  return (
    <Tooltip title={actionText.text}>
      <Chip
        label={actionText.short}
        sx={{
          bgcolor: `semantic.action.${actionText.tint}.soft`,
          color: `semantic.action.${actionText.tint}.text`,
          fontSize: '14px',
          fontWeight: 'bold',
        }}
      />
    </Tooltip>
  );
};
